export default __webpack_public_path__ + "static/media/3stepweightloss_3.463d8ee0.jpg";